import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";

// Styled Components
export const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <props.IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
}));

export const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 15,
  height: 15,
  border: `2px solid ${theme.palette.background.paper}`,
}));

// Common Typography styles
export const titleTypography = (theme) => ({
  fontSize: theme.fontSizes.extraMedium,
  fontWeight: theme.fontWeight.normal,
  fontFamily: theme.fonts.regular,
  // Force truncation with a reliable `...` at the end.
  // MUI/CardHeader often uses flex layouts where `minWidth` must be 0
  // for ellipsis to work correctly.
  display: "block",
  minWidth: 0,
  flexShrink: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "230px",
  lineHeight: 1.2,
  // Card body Stack uses pointerEvents: "none" so clicks bubble to Card; hover must be re-enabled
  // or native `title` and MUI Tooltip never receive pointer events.
  pointerEvents: "auto",
});

export const labelTypography = (theme) => ({
  fontSize: theme.fontSizes.extraMedium,
  fontWeight: theme.fontWeight.normal,
  fontFamily: theme.fonts.regular,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  maxWidth: "180px",
});

export const dropDownMenu = {
  fontSize: "14px",
  "&:hover": { backgroundColor: "#E2EFDF" },
};

export const valueTypography = (theme) => ({
  fontSize: "12px",
  fontFamily: theme.fonts.regular,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  maxWidth: "180px",
});

export const cardSx = {
  minWidth: 280,
  maxWidth: 280,
  display: "flex",
  flexDirection: "column",
  p: 1,
  flexShrink: 0,
};

export const cardHeaderSx = {
  padding: "4px",
  display: "flex",
};

export const cardContentSx = {
  paddingTop: 1,
  paddingBottom: 0,
};

export const checkInButtonSx = (theme) => ({
  textTransform: "none",
  backgroundColor: theme.colors.themeDarkColor,
  fontSize: "12px",
  fontFamily: theme.fonts.regular,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  maxWidth: "180px",
});

export const dividerSx = (theme) => ({
  marginLeft: "4px",
  marginRight: "4px",
  borderColor: theme.colors.dividerColor,
});
